import styled from 'styled-components';

const Container = styled.div``;

const Header = styled.div`
  margin-bottom: 2.4rem;

  display: flex;
  justify-content: space-between;
`;

const Tabs = styled.div``;

export { Container, Header, Tabs };
